import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';
import PaymentReserveChange from 'components/features/payment-reserve-change';

function PaymentReserveChanges() {
  const { t } = useTranslation();
  return (
    <HomeLayout title={t('claim.claim')}>
      <PaymentReserveChange />
    </HomeLayout>
  );
}

export default PaymentReserveChanges;
